import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.server.availableStorage;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	method: 'POST',
	actionType: 'SERVER_AVAILABLESTORAGE',
	url: '/server/availableStorage.json',
});

export { actions, reducer, sagas, selectors };
